import { createContext } from "react";

export const SettingContext = createContext();
export const GobalContext = createContext();
export const MuiContext = createContext();
export const BootstrapContext = createContext();